import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class StampSelector extends Command {
    constructor() {
        super({
            Enabled: true,
            Key: GlobalVariables.StampSelectorID,
            Path: false,
            Callback: () => {
                return;
            },
        });
    }
}
